import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function client() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${token}` }
    });
}

/** @returns {Promise<object>} SkudScanResponseDto */
export async function scanSkud(scannedToken, groupId) {
    const res = await client().post('/skud/scan', { token: scannedToken, groupId: groupId ?? null });
    return res.data;
}

export async function issueStudentQr(studentId) {
    const res = await client().post(`/qr/students/${studentId}/issue`);
    return res.data;
}

export async function issueStaffQr() {
    const res = await client().post('/qr/staff/issue');
    return res.data;
}
